import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';

const CurrentPlanButton = ({
  ctaStyles
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    disabled: true,
    style: ctaStyles,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "suiteFeatureTable.currentPlan"
    })
  });
};

export default CurrentPlanButton;